import styled from 'styled-components';
import { IArrow } from '..';
import { mediaQuery } from '../../../utils/mediaQuery';

export const RoomPickerWrapper = styled.div`
  width: 160px;
  height: 98px;
  flex-shrink: 0;
  position: relative;
  padding: 0 10px;
`;

export const RoomImagenWrapper = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 3px;
`;

export const RoomNameWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 3px;
  color: #ffffff;
  font-size: 1.063rem;
  font-weight: bold;
  padding: 5px 20px;
`;

export const ForwardCarouselWrapper = styled.button`
  position: absolute;
  top: 26px;
  right: 0;
  background-color: transparent;
  border: 0;
  width: 52px;
  height: 52px;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease 0s;
`;
export const BackCarouselWrapper = styled.button`
  position: absolute;
  top: 26px;
  left: 0;
  background-color: transparent;
  border: 0;
  transform: rotate(180deg);
  width: 52px;
  height: 52px;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease 0s;
`;

export const RoomContainerWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;

  ${RoomPickerWrapper} {
    scroll-snap-align: start;
  }

  ${RoomPickerWrapper}:first-child {
    padding-left: 0;

    ${RoomNameWrapper} {
      left: 0;
    }
  }

  ${RoomPickerWrapper}:last-child {
    padding-right: 0;
  }
`;

export const CarouselWrapper = styled.div`
  overflow: hidden;
  position: relative;

  &:hover ${ForwardCarouselWrapper}, &:hover ${BackCarouselWrapper} {
    opacity: 1;
  }
`;

export const MenuWrapper = styled.div`
  position: relative;
  max-width: 500px;
  height: 100px;
  margin: 1em auto;
  border: 1px solid black;
  overflow-x: hidden;
  overflow-y: hidden;
`;

export const Menu = styled.div`
  height: 120px;
  background: #f3f3f3;
  box-sizing: border-box;

  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
`;

export const ArrowsContainer = styled.div`
  & button {
    position: absolute;
    bottom: 0;
    width: 36px;
    height: 36px;
    background: #ffffff;
    top: 50%;
    transform: translate(0, -50%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 42px;
    border: none;
    align-items: center;
    justify-content: center;
    z-index: 2;
    transition: 0.2s all;
    cursor: pointer;
    margin: 5px;
  }
`;

export const LeftArrow = styled.button<IArrow>`
  left: ${({ margin = 0 }) => margin}em;
  display: flex;
  opacity: ${({ visible = true }) => (visible ? 1 : 0)};
  visibility: ${({ visible = true }) => (visible ? 'visible' : 'hidden')};
  ${mediaQuery.mobileOnly(`
    display: none;
  `)}
`;

export const RightArrow = styled.button<IArrow>`
  right: ${({ margin = 0 }) => margin}em;
  display: flex;
  opacity: ${({ visible = true }) => (visible ? 1 : 0)};
  visibility: ${({ visible = true }) => (visible ? 'visible' : 'hidden')};
  ${mediaQuery.mobileOnly(`
    display: none
  `)}
  ${mediaQuery.tabletToUp(`

  `)}
`;
